import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@core/services';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const auth: AuthService = inject(AuthService);
  const token: string | null = auth.token();
  const client_id: string | null = auth.client_id();

  if (token && client_id) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
      setParams: {
        'client-id': `${client_id}`,
      },
    });
  }

  return next(req);
};
